import { MyCompanyCategory } from '../types';

export interface DetailedCategory {
  id?: number;
  name?: string;
  details?: string;
  myCompanyLinks?: CompanyCategory[];
}

export interface CompanyCategory {
  id: number;
  name: string;
  url: string;
}

export const mapDetailedCategory = (
  categories: MyCompanyCategory[],
  lookupCode: string
): DetailedCategory => {
  const selectedCategory = categories.find(
    (category) => category.id.toString() === lookupCode
  );

  return {
    id: selectedCategory?.id,
    name: selectedCategory?.name,
    details: selectedCategory?.details,
    myCompanyLinks: selectedCategory?.my_company_category_links?.map(
      (links: CompanyCategory) => ({
        id: links.id,
        name: links.name,
        url: links.url,
      })
    ),
  };
};
